import { ChevronRight, Play, type LucideIcon } from "lucide-react";
import { Link } from "react-router";
import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from "@/components/ui/collapsible";
import {
	SidebarGroup,
	SidebarGroupLabel,
	SidebarMenu,
	SidebarMenuAction,
	SidebarMenuButton,
	SidebarMenuItem,
	SidebarMenuSub,
	SidebarMenuSubButton,
	SidebarMenuSubItem,
} from "@/components/ui/sidebar";
import { NavLink } from "react-router";
import { Button } from "@/components/ui/button";

export type NavMainItems = {
	title: string;
	url: string;
	icon: LucideIcon;
	isActive?: boolean;
	items?: {
		title: string;
		url: string;
	}[];
}[];

export function NavMain({ items }: { items: NavMainItems }) {
	return (
		<SidebarGroup>
			<Link to="/start">
				<Button className="w-full mb-2">
					<Play />
					Start Now
				</Button>
			</Link>
			<SidebarGroupLabel>Sounds</SidebarGroupLabel>
			<SidebarMenu>
				{items.map((item) => (
					<Collapsible key={item.title} asChild defaultOpen={item.isActive}>
						<SidebarMenuItem>
							{item.url === "#" ? (
								<SidebarMenuButton asChild tooltip={item.title}>
									<CollapsibleTrigger>
										<item.icon />
										<span>{item.title}</span>
									</CollapsibleTrigger>
								</SidebarMenuButton>
							) : (
								<NavLink to={item.url} end className="contents">
									{({ isActive }) => (
										<SidebarMenuButton tooltip={item.title} isActive={isActive}>
											<item.icon />
											<span>{item.title}</span>
										</SidebarMenuButton>
									)}
								</NavLink>
							)}
							{item.items?.length ? (
								<>
									<CollapsibleTrigger asChild>
										<SidebarMenuAction className="data-[state=open]:rotate-90">
											<ChevronRight />
											<span className="sr-only">Toggle</span>
										</SidebarMenuAction>
									</CollapsibleTrigger>
									<CollapsibleContent>
										<SidebarMenuSub>
											{item.items?.map((subItem) => (
												<SidebarMenuSubItem key={subItem.title}>
													<NavLink to={subItem.url} className="contents">
														{({ isActive }) => (
															<SidebarMenuSubButton asChild isActive={isActive}>
																<span>{subItem.title}</span>
															</SidebarMenuSubButton>
														)}
													</NavLink>
												</SidebarMenuSubItem>
											))}
										</SidebarMenuSub>
									</CollapsibleContent>
								</>
							) : null}
						</SidebarMenuItem>
					</Collapsible>
				))}
			</SidebarMenu>
		</SidebarGroup>
	);
}
